import React from 'react';
import {
  useDispatch,
} from "react-redux";

// Layout
import DetailsSidebarFrontBaseLayout from "../../../layouts/detailsSidebarFrontBaseLayout";

// Components
import BackIcon from '../../../components/atoms/icons/back';
import SendIcon from '../../../components/atoms/icons/send';

// Hooks
import useTheme from "../../../theme-style/useThemeCustomHook";

// Store
import {
  setMessageFromSideBar
} from '../../../../../store/chatbot/actions';

// Styles
import {
  Container,
  SkillsWrapper,
  Header,
  BackButton,
  Title,
  BackIconWrapper,
  SkillsList,
  SkillsItem,
  SkillsItemCircle,
  SkillsItemContent,
  SkillsItemTitle,
  SkillsItemText,
  SendIconWrapper
} from "../style";

const Exchange = () => {
  const theme = useTheme();
  const dispatch = useDispatch();

  const onSkillsItemClick = (message) => {
    dispatch(setMessageFromSideBar(message));
  }

  return (
    <DetailsSidebarFrontBaseLayout
      id="detailsSidebarLayoutSkillsHelpers"
      className="detailsSidebarLayoutSkillsHelpers page-container sidebarPage"
    >
      <Container>
        <SkillsWrapper>
          <Header to="/competences">
            <BackButton>
              <BackIconWrapper>
                <BackIcon color={theme.colors.white}/>
              </BackIconWrapper>
            </BackButton>
            <Title>
              Cyconia échange 💬
            </Title>
          </Header>

          <SkillsList>
            <SkillsItem
              onClick={() => onSkillsItemClick(
                "Comment tu vas ?"
              )}
            >
              <SkillsItemCircle> H </SkillsItemCircle>
              <SkillsItemContent>
                <SkillsItemTitle>
                  Humeur
                </SkillsItemTitle>
                <SkillsItemText>
                  Comme vous, Cyconia a ses humeurs 🌤
                </SkillsItemText>
              </SkillsItemContent>
              <SendIconWrapper>
                <SendIcon />
              </SendIconWrapper>
            </SkillsItem>
            <SkillsItem
              onClick={() => onSkillsItemClick(
                "Tu connais Siri ?"
              )}
            >
              <SkillsItemCircle> L </SkillsItemCircle>
              <SkillsItemContent>
                <SkillsItemTitle>
                  Les confrères Cyconia
                </SkillsItemTitle>
                <SkillsItemText>
                  Vous connaissez certainement des confrères de Cyconia. Eh bien, lui aussi ! 🗞
                </SkillsItemText>
              </SkillsItemContent>
              <SendIconWrapper>
                <SendIcon />
              </SendIconWrapper>
            </SkillsItem>
            <SkillsItem
              onClick={() => onSkillsItemClick(
                "Raconte-moi une blague !"
              )}
            >
              <SkillsItemCircle> C </SkillsItemCircle>
              <SkillsItemContent>
                <SkillsItemTitle>
                  Cyconia Détente
                </SkillsItemTitle>
                <SkillsItemText>
                  Il y a quelques questions que vous pouvez poser et qui déclenchent des réponses drôles 🌤
                </SkillsItemText>
              </SkillsItemContent>
              <SendIconWrapper>
                <SendIcon />
              </SendIconWrapper>
            </SkillsItem>
            <SkillsItem
              onClick={() => onSkillsItemClick(
                "Apprends-moi quelque chose"
              )}
            >
              <SkillsItemCircle> C </SkillsItemCircle>
              <SkillsItemContent>
                <SkillsItemTitle>
                  Cultivons-nous
                </SkillsItemTitle>
                <SkillsItemText>
                  Cyconia est capable de vous apprendre des choses, demandez-lui ! 🗞
                </SkillsItemText>
              </SkillsItemContent>
              <SendIconWrapper>
                <SendIcon />
              </SendIconWrapper>
            </SkillsItem>

          </SkillsList>
        </SkillsWrapper>
      </Container>
    </DetailsSidebarFrontBaseLayout>
  );
}

export default Exchange;
